import AxiosService from "../AxiosService";

export default class ReportService {
    constructor() {
        this.service = new AxiosService();
    }

    requestHTML(id) {
        return this.service.get(`/api/v1/report/${id}`);
    }

}
